import { HttpClientPlugin } from '../types';
import { getGuestIdFromCookieClient } from '@/src/lib/guest/business/get-guest-id.client';
import { createWithGuestHeaderPlugin } from '@/src/lib/http/plugins/with-guest-header';

export function createWithGuestHeaderClientPlugin(): HttpClientPlugin {
  return createWithGuestHeaderPlugin(getGuestIdFromCookieClient);
}
